<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
        </div>

        <div class="content-card " style="border-color: transparent">
            <img src="{{urlBanner}}" alt="Logo-Norm35" class="centradoIMG ">
            <!-- <img src="./../../../../../assets/images/norm35/Mesa de trabajo 4.png" alt="Logo-Norm35" class="centradoIMG "> -->
        </div>
        <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->
    <!-- CONTENT -->
    <div class="content-card" style="margin-top: 2%; margin-left: 5%; margin-right: 15%;">
        <span>{{ 'WIZARD.DEFINICIONES_NORMA.SPAN02' | translate}}</span>
        <div *ngFor="let datita of dataDef">
            <p class="strongTittle"> {{datita.tittle | translate}}</p>
            <p> {{datita.definicion | translate}}</p>
        </div><br>

    </div>

</div>
<!-- / CENTER -->